import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  selectsubscriptionUriError
} from '../ManualAccessPage/selectors';

const WithoutSubscription = ({ subscriptionUri }) => (
  <React.Fragment>
    <p>
      Você ainda não está assinado no serviço, por favor faça o login&nbsp;
      <a href={subscriptionUri}>{subscriptionUri}</a>
    </p>
  </React.Fragment>
);

WithoutSubscription.defaultProps = {
  subscriptionUri: ''
};

WithoutSubscription.propTypes = {
  subscriptionUri: PropTypes.string
};

const mapStateToProps = (state) => ({
  subscriptionUri: selectsubscriptionUriError(state)
});

export default connect(mapStateToProps)(WithoutSubscription);



// WEBPACK FOOTER //
// ./src/containers/WithoutSubscriptionPage/index.js